<section *ngIf="!data.template; else templateContainer"
  [ngStyle]="{ 'border-bottom': (data.noDefault && !data.showBorder) ? 'none' : '1px solid #ccc', 'padding-bottom': '5px' }">
  <h5 class="mb-1 bg-primary text-white p-2" style="background-color: #007bc6 !important" *ngIf="data.heroTitle">
    {{ model ? data.heroTitle : data.heroTitleCreate }}
    <span>
      {{ model?.[data.noDefault ? data.fieldIdentificativo : (data.fieldIdentificativo || 'identificativo')] || "" }}
    </span>
  </h5>
  <div>
    <div class="row align-items-start">
      <div class="col-6 text-start">
        <span class="py-1 px-2 fw-semibold"
          style="font-size:15px; display: block; max-width: 100%; overflow-wrap: break-word; white-space: normal; text-align: left; border-radius: 0;"
          *ngIf="model?.[data.noDefault ? data.fieldDescription : (data.fieldDescription || 'oggetto')]">
          {{ model?.[data.noDefault ? data.fieldDescription : (data.fieldDescription || 'oggetto')] }}
        </span>
      </div>
      <div class="col-6 text-end text-secondary" style="font-size:12px;">
        <div>
          <span class="d-block fw-semibold"
            *ngIf="model?.[data.noDefault ? data.fieldCreatedAt : (data.fieldCreatedAt || 'createdAt')]"
            style="padding-right: 5px;">
            Data creazione:
            {{ model?.[data.noDefault ? data.fieldCreatedAt : (data.fieldCreatedAt || 'createdAt')] }}
          </span>
          <span class="d-block fw-semibold"
            *ngIf="model?.[data.noDefault ? data.fieldUpdatedAt : (data.fieldUpdatedAt || 'updatedAt')]"
            style="padding-right: 5px;">
            Data ultima modifica:
            {{ model?.[data.noDefault ? 'updatedAt' : (data.fieldUpdatedAt || 'updatedAt')] }}
          </span>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #templateContainer>
  <div [innerHTML]="safeHtml"></div>
</ng-template>